'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require('events');

var EventEmitter = _require.EventEmitter;

var Buffer = require('safe-buffer').Buffer;

var _KBucket = require('k-bucket');

var KBUCKET_SIZE = 16;
var KBUCKET_CONCURRENCY = 3;

var KBucket =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(KBucket, _EventEmitter);

  function KBucket(id) {
    var _this;

    _classCallCheck(this, KBucket);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KBucket).call(this));
    _this._peers = new Map();
    _this._kbucket = new _KBucket({
      localNodeId: id,
      numberOfNodesPerKBucket: KBUCKET_SIZE,
      numberOfNodesToPing: KBUCKET_CONCURRENCY
    });

    _this._kbucket.on('added', function (peer) {
      KBucket.getKeys(peer).forEach(function (key) {
        return _this._peers.set(key, peer);
      });

      _this.emit('added', peer);
    });

    _this._kbucket.on('removed', function (peer) {
      KBucket.getKeys(peer).forEach(function (key) {
        return _this._peers.delete(key, peer);
      });

      _this.emit('removed', peer);
    });

    _this._kbucket.on('ping', function () {
      var _this2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_this2 = _this).emit.apply(_this2, ['ping'].concat(args));
    });

    return _this;
  }

  _createClass(KBucket, [{
    key: "add",
    value: function add(peer) {
      var _this3 = this;

      var isExists = KBucket.getKeys(peer).some(function (key) {
        return _this3._peers.has(key);
      });
      if (!isExists) this._kbucket.add(peer);
    }
  }, {
    key: "get",
    value: function get(obj) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = KBucket.getKeys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var peer = this._peers.get(key);

          if (peer !== undefined) return peer;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._kbucket.toArray();
    }
  }, {
    key: "closest",
    value: function closest(id) {
      return this._kbucket.closest(id, KBUCKET_SIZE);
    }
  }, {
    key: "remove",
    value: function remove(obj) {
      var peer = this.get(obj);
      if (peer !== null) this._kbucket.remove(peer.id);
    }
  }], [{
    key: "getKeys",
    value: function getKeys(obj) {
      if (Buffer.isBuffer(obj)) return [obj.toString('hex')];
      if (typeof obj === 'string') return [obj];
      var keys = [];
      if (Buffer.isBuffer(obj.id)) keys.push(obj.id.toString('hex'));
      if (obj.address && obj.port) keys.push("".concat(obj.address, ":").concat(obj.port));
      return keys;
    }
  }]);

  return KBucket;
}(EventEmitter);

module.exports = KBucket;